import { InvoiceData } from "@/models/api/administration/onyxFix/InvoiceData";
import { axiosInstance } from "@/plugins/axios";

//#region Routes
export const URL_POST_ONYX_FIX_PREVIEW = "/OnyxFix/GetPreview";
export const URL_POST_ONYX_FIX_SEND_CORRECTION = "/OnyxFix/SendCorrection";
//#endregion

export const getOnyxFixPreview = async (file: File, data: InvoiceData): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("data", JSON.stringify(data));

  const response = await axiosInstance.post(URL_POST_ONYX_FIX_PREVIEW, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "preview.xml");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const sendToKsefOnyxCorrection = async (file: File, data: InvoiceData): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("data", JSON.stringify(data));

  await axiosInstance.post(URL_POST_ONYX_FIX_SEND_CORRECTION, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
